const contractOptions = [
	{
		key: 0,
		value:
			'0-30',
		label:
			'0-30',
	},
	{
		key: 1,
		value:
			'31-50',
		label:
			'31-50',
	},
	{
		key: 2,
		value:
			'51-100',
		label:
			'51-100',
	},
	{
		key: 3,
		value:
			'101-250',
		label:
			'101-250',
	},
	{
		key: 4,
		value:
			'250+',
		label:
			'250+',
	},
	{
		key: 5,
		value:
			'Not Sure',
		label:
			'Not Sure',
	}
]

export default contractOptions
